import validate from "/app/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_eslint@9.28.0_jiti@2.4_d3680cf355ec63b27af743453fdb42ad/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/app/services/upgrade/src/middleware/auth.global.ts";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.29_db0@0.3.2_eslint@9.28.0_jiti@2.4_d3680cf355ec63b27af743453fdb42ad/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}